import { type VehicleManager } from './VehicleManager';
import { type VehicleCustomLayer } from '../components/MapLibre/VehicleCustomLayer';

export class AnimationManager {
  vehicleManager: VehicleManager;
  vehicleLayer: VehicleCustomLayer;
  isAnimating: boolean;

  constructor(vehicleManager: VehicleManager, vehicleLayer: VehicleCustomLayer) {
    this.vehicleManager = vehicleManager;
    this.vehicleLayer = vehicleLayer;
    this.isAnimating = false;
  }

  start() {
    this.isAnimating = true;
    this.animate();
  }

  stop() {
    this.isAnimating = false;
  }

  private readonly animate = () => {
    if (!this.isAnimating) return;

    // Mettre à jour les positions des véhicules
    this.vehicleLayer.updateVehiclePositions();

    // Demander un repaint de la carte
    this.vehicleLayer.map.triggerRepaint();

    requestAnimationFrame(this.animate);
  };
}
